import * as yup from 'yup';

export const schema = yup.object({
  cod_loja: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  cod_pessoa: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  tipo_frequencia: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  cod_cc: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  cod_finalizadora: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  cod_categoria: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  tipo_dta_entrada: yup.object({
    value: yup.number().required(),
    label: yup.string().required(),
  }),
  dta_docto: yup.string().required(),
  val_docto: yup.string().required(),
});
